(function() {
    // 1. SID & UTM Logic (from App.jsx)
    function initTracking() {
        const params = new URLSearchParams(window.location.search);
        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
        const hasNewUtm = utmKeys.some(key => params.get(key));

        let sid = localStorage.getItem('event_sid');
        if (hasNewUtm || !sid) {
            sid = 'idx-' + Math.random().toString(36).substr(2, 9) + '-' + Date.now();
            localStorage.setItem('event_sid', sid);
        }

        const utmObj = {};
        utmKeys.forEach(key => {
            const val = params.get(key);
            if (val) utmObj[key] = val;
        });

        if (Object.keys(utmObj).length === 0) {
            utmObj.utm_source = 'direct';
            utmObj.utm_medium = 'none';
            utmObj.utm_campaign = 'unknown';
        }
        // localStorage.setItem('event_utm', JSON.stringify(utmObj));

        // Send UTM Log
        // fetch('https://api.medihealcos.net/event-api/uk/membership/utm-log', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({
        //         sid,
        //         ...utmObj,
        //         referrer: document.referrer || null,
        //         landing_path: window.location.pathname
        //     })
        // }).catch(err => console.error('UTM log failed', err));

        return sid;
    }

    const currentSid = initTracking();

    // 2. Navigation
    window.goToPage = function(pageId) {
        document.querySelectorAll('.page-section').forEach(p => p.classList.add('hidden'));
        document.getElementById('page-' + pageId).classList.remove('hidden');
        window.scrollTo(0, 0);
    };

    // 3. Form Validation (from Form.jsx - confirmInfo)
    function validateForm() {
        const emailRegExp = /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/;
        const firstName = document.getElementById('firstName').value.trim();
        const lastName = document.getElementById('lastName').value.trim();
        const email = document.getElementById('email').value.trim();
        const region = document.getElementById('region').value;
        const agreed = document.getElementById('agreed-checkbox').checked;

        if (!firstName) { alert('Please enter your first name.'); document.getElementById('firstName').focus(); return false; }
        if (!lastName) { alert('Please enter your last name.'); document.getElementById('lastName').focus(); return false; }
        if (!email || !emailRegExp.test(email)) { alert('Please enter a valid email address.'); document.getElementById('email').focus(); return false; }
        if (!region) { alert('Please select your region.'); document.getElementById('region').focus(); return false; }
        if (!agreed) { alert('Please agree to the Privacy Policy.'); return false; }

        return { firstName, lastName, email, region };
    }

    // 4. Submit Logic
    window.submitForm = async function() {
        const formData = validateForm();
        if (!formData) return;

        try {
            const response = await fetch('https://api.medihealcos.net/event-api/uk/membership/entry', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    sid: currentSid,
                    ...formData
                })
            });

            const result = await response.json();
            if (response.ok && result.success !== false) {
                goToPage('complete');
            } else {
                throw new Error(result.message || 'Server Error');
            }
        } catch (err) {
            alert(err.message);
            // Optional: Redirect to Boots as per original code
            // window.location.href = 'http://boots.com/sitesearch?searchTerm=mediheal';
        }
    };

    // 5. Modal Logic
    window.openPolicy = function() {
        document.getElementById('modal-dim').style.display = 'block';
        document.getElementById('modal-policy').classList.add('active');
    };

    window.closePolicy = function() {
        document.getElementById('modal-dim').style.display = 'none';
        document.getElementById('modal-policy').classList.remove('active');
    };

    window.confirmPolicy = function(agreed) {
        document.getElementById('agreed-checkbox').checked = agreed;
        closePolicy();
    };
})();